import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { Metric } from 'src/constants/types';
import { RootState } from 'src/store';
import { CompanyCounters, TimePeriod } from '../types';
import { HomeState } from './types';

const initialState: HomeState = {
  loading: { metrics: false, counters: false },
  metrics: [],
  counters: {
    contactsCount: 0,
    activeCampaignsCount: 0,
    keywordCount: 0,
    activeGroupsCount: 0,
  },
  filter: {
    timePeriod: TimePeriod.LAST90DAYS,
    startDateInterval: dayjs(new Date()).startOf('day').subtract(90, 'days').toISOString().substring(0, 10),
    endDateInterval: null,
  },
  error: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<HomeState['loading']>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setMetrics: (state, action: PayloadAction<Metric[]>) => {
      state.metrics = action.payload;
    },
    setCounters: (state, action: PayloadAction<CompanyCounters>) => {
      state.counters = action.payload;
    },
    setFilter: (state, action: PayloadAction<Partial<HomeState['filter']>>) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetHome: () => initialState,
  },
});

export const { setLoading, setMetrics, setCounters, setFilter, setError, resetHome } =
  homeSlice.actions;

export const homeReducer = homeSlice.reducer;

export const selectHomeLoading = (state: RootState) => state.home.loading;
export const selectHomeMetrics = (state: RootState) => state.home.metrics;
export const selectHomeCounters = (state: RootState) => state.home.counters;
export const selectHomeFilter = (state: RootState) => state.home.filter;
export const selectHomeError = (state: RootState) => state.home.error;
